import { render, staticRenderFns } from "./i9Reports.vue?vue&type=template&id=5b1a6022&"
import script from "./i9Reports.vue?vue&type=script&lang=js&"
export * from "./i9Reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports